import { cancellationSelectorsFactory } from 'state/secondaryMarket/shared/cancellation/cancellationSelectorsFactory';

export const cpOrderCancellationSelectors = cancellationSelectorsFactory('cpOrder');
